import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * South African ID generator following Single Responsibility Principle
 */
export class ZaGenerator extends BaseGenerator {
  generate(options = {}) {
    const { birthDate = null, gender = null } = options;

    // Birth date (6 digits: YYMMDD)
    let yymmdd;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear().toString().slice(-2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      yymmdd = year + month + day;
    } else {
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      yymmdd = year + month + day;
    }

    // Gender digit (1 digit: 0-4 female, 5-9 male)
    let genderDigit;
    if (gender === 'male') {
      genderDigit = this.randomInt(5, 9);
    } else if (gender === 'female') {
      genderDigit = this.randomInt(0, 4);
    } else {
      genderDigit = this.randomInt(0, 9);
    }

    // Sequence number (3 digits)
    const sequence = this.randomDigits(3);

    // Citizenship (1 digit: 0 = SA citizen, 1 = permanent resident)
    const citizenship = this.randomInt(0, 1);

    // Race (1 digit - historically used, now usually 8 or 9)
    const race = this.randomInt(8, 9);

    // Calculate Luhn check digit
    const partial = yymmdd + genderDigit + sequence + citizenship + race;
    let sum = 0;
    let alternate = false;

    for (let i = partial.length - 1; i >= 0; i--) {
      let n = parseInt(partial[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return partial + checkDigit;
  }
}